import { defineComponent, ref, computed, inject, watch, watchEffect } from 'vue';
import { useLocalizationSupport } from '../../composables/localization-support/index.js';
import { useStoreModule } from '../../composables/store-module/index.js';
import { getValidationErrors } from '../../helpers/validation.js';
import { generateElementId } from '../../helpers/generators.js';

var _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "PortfolioCreate",
  props: {
    locale: { type: null, required: true }
  },
  emits: ["store-error", "data-load", "cancel", "submit"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const name = ref(null);
    const currency = ref(null);
    const action = ref("FETCH");
    const nameInputId = generateElementId("fds-portfolio-create-name-input-");
    const currencyInputId = generateElementId("fds-portfolio-create-currency-input-");
    const validationNameErrorsBag = ref([]);
    const componentInputs = computed(() => {
      var _a;
      return {
        currency: currency.value,
        action: action.value,
        name: (_a = name.value) != null ? _a : "",
        language: props.locale
      };
    });
    const currencies = computed(() => {
      var _a, _b;
      return (_b = (_a = storeData.value) == null ? void 0 : _a.currencies) != null ? _b : [];
    });
    const changeName = (newName) => {
      name.value = newName;
    };
    const changeCurrency = (newCurrency) => {
      currency.value = newCurrency;
    };
    const onCreate = async () => {
      validateName();
      if (!isLoadingStoreData.value && hasValidName.value) {
        action.value = "CREATE";
        await storeCleanUp(componentInputs.value);
        const portfolioId = await storeRequestData();
        if (portfolioId && typeof portfolioId !== "boolean") {
          emits("submit", portfolioId);
        }
        action.value = "FETCH";
      }
    };
    const onCancel = () => {
      name.value = null;
      currency.value = null;
      emits("cancel");
    };
    const validateName = () => {
      var _a, _b;
      validationNameErrorsBag.value = getValidationErrors((_a = name.value) != null ? _a : "", (_b = storeMeta.value) == null ? void 0 : _b.validationRules.name);
    };
    const hasValidName = computed(() => validationNameErrorsBag.value.length === 0);
    const localizationSupport = useLocalizationSupport(props, {
      translator: inject("translator"),
      numberFormatter: inject("numberFormatter"),
      dateFormatter: inject("dateFormatter")
    });
    const { translate } = localizationSupport;
    const storeModule = useStoreModule(
      { storeModule: inject("storeModule") },
      componentInputs,
      emits,
      { requestDataOnComponentInputsChange: false }
    );
    const { storeData, storeMeta, storeRequestData, isLoadingStoreData, storeErrorsBag, storeCleanUp } = storeModule;
    watch(storeErrorsBag.value, (newStoreErrorsBagValue) => {
      if (newStoreErrorsBagValue.length > 0) {
        emits("store-error", newStoreErrorsBagValue);
      }
    });
    watchEffect(() => {
      if (currency.value === null && currencies.value.length > 0) {
        currency.value = currencies.value[0].id;
      }
    });
    return { __sfc: true, name, currency, action, nameInputId, currencyInputId, validationNameErrorsBag, props, emits, componentInputs, currencies, changeName, changeCurrency, onCreate, onCancel, validateName, hasValidName, localizationSupport, translate, storeModule, storeData, storeMeta, storeRequestData, isLoadingStoreData, storeErrorsBag, storeCleanUp };
  }
});

export { _sfc_main as default };
